import Vue from "vue";
import Vuex from "vuex";
import authentication from "./modules/authentication";
import fetchvigator from "./modules/fetchvigator";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    authentication,
    fetchvigator,
  },
});
